/** @jsxImportSource @emotion/react */
import { Trans, useLingui } from '@lingui/react/macro';
import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { steps } from 'modules/main/domain/const/steps';
import { StepperMainTool } from 'modules/main/domain/utils/stepper-tool';
import { fetchMainPageInfo, selectStatus } from 'modules/main/store/main-page';
import Stepper from 'modules/main/ui/components/stepper/stepper';
import SectionNews from 'modules/main/ui/pages/main-page/sections/section-news/section-news';
import SectionPlayers from 'modules/main/ui/pages/main-page/sections/section-players/section-players';
import SectionTeams from 'modules/main/ui/pages/main-page/sections/section-teams/section-teams';
import SectionTournaments from 'modules/main/ui/pages/main-page/sections/section-tournaments/section-tournaments';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch } from 'store/store';
import type { DivProps } from 'typings';
import UDHeaderTitle from 'ud-ui/components/header-title';
import { useMainLayout } from 'modules/app-shell/ui/layout/context';
import * as S from './styles';

interface IProps extends DivProps {}

function MainPage(props: IProps) {
  const { ...rest } = props;
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useLingui();
  const { setHeaderContent } = useMainLayout();
  const userTournamentId = useSelector(authStoreUserTournamentId);
  const status = useSelector(selectStatus);

  useEffect(() => {
    setHeaderContent(
      <UDHeaderTitle>
        <Trans>Главная</Trans>
      </UDHeaderTitle>,
    );
    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  // обновляем статистику при каждом заходе на дашборд, чтобы цифры не устаревали после создания сущностей
  useEffect(() => {
    if (!userTournamentId) return;
    dispatch(fetchMainPageInfo({ tournamentId: userTournamentId }));
  }, [dispatch, userTournamentId]);

  const [isOpenStepper, setOpenStepper] = useState(!StepperMainTool.getByPath('stepper:main:close'));
  const isLoading = status.loading && !status.loaded;

  const closeStepper = useCallback(() => {
    setOpenStepper(false);
    StepperMainTool.setByPath('stepper:main:close', true);
  }, []);

  return (
    <S.MainBlock {...rest}>
      {/* Бегущая строка — сразу под шапкой, выше приветствия и карточек: новости видны без прокрутки. */}
      <SectionNews />

      <Stepper
        header={t`Привет! 👋`}
        subtitle={t`Давай запустим первый турнир по схеме ниже`}
        steps={steps}
        onClose={closeStepper}
        isOpened={isOpenStepper}
      />

      <S.SectionsWrapper>
        <SectionTeams style={{ minWidth: 340 }} loading={isLoading} />
        <SectionPlayers style={{ minWidth: 375 }} loading={isLoading} />
        <SectionTournaments style={{ minWidth: 325 }} loading={isLoading} />
      </S.SectionsWrapper>
    </S.MainBlock>
  );
}

export default MainPage;
